<template>
    <v-app>
        <v-container id="request">
            <v-row justify="center" align="center" cols="2" class="mt-3">
                <v-col cols="12">
                    <router-link class="grey--text" to="/">&laquo; Back to Dashboard</router-link>
                </v-col>
                <v-col cols="12">
                    <h1 class="blue-grey--text text--darken-3">Request Details</h1>
                </v-col>
            </v-row>
            <v-row justify="center" align="center">
                <v-col>
                    <v-card elevation="5" class="mb-3 pl-4 pr-4 pb-4">
                        <v-card-text>
                            <div class="mb-3 mt-3">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                                small
                                                color="red"
                                                class="mr-2"
                                                v-bind="attrs"
                                                v-on="on"
                                                v-if="request.urgent">
                                            mdi-alert-circle-outline</v-icon>
                                    </template>
                                    <span>Urgent</span>
                                </v-tooltip>
                                <v-chip
                                        class="white--text"
                                        small
                                        :color="statusColor"
                                >
                                    {{ this.request.status }}
                                </v-chip>
                            </div>
                            <div class="mb-3 ">
                                <span class="mr-2">Ticket ID: {{ this.request.ticketID }}</span> |
                                <span class="ml-2 mr-2">Submitted: {{ new Date(this.request.createdAt).toLocaleDateString() }}</span> |
                                <span class="ml-2 mr-2">Due: {{ new Date(this.request.dueDate+"T12:00:00").toLocaleDateString() }}</span> |
                                <span class="ml-2">Requestor: {{ `${ this.request.user.firstName} ${ this.request.user.lastName.substr(0, 1)}.` }}</span>
                            </div>
                            <p class="display-1 text--primary">

                                {{ this.request.title }}
                            </p>
                            <div class="text--primary">
                                <div v-for="(item, index) in request.pages.items" :key="index">
                                    <h4>Page #{{ index + 1 }} :  {{ item.url }}</h4>
                                    <p class="mt-1">{{ item.description }}</p>
                                    <v-divider class="mt-4 mb-4"></v-divider>
                                </div>
                                <h4 v-if="request.files.items.length > 0">Files:</h4>
                                <ul>
                                    <li v-for="(item, index) in request.files.items" :key="index">
                                        {{ item.name }}
                                    </li>
                                </ul>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
    import { API, graphqlOperation } from 'aws-amplify'
    import { getRequest } from "../graphql/queries";

    export default {
        name: "ViewRequest",
        props: ['id'],
        methods: {
            async getRequest(id) {
                await API.graphql(graphqlOperation(getRequest, {id: id}))
                    .then(response => {
                        this.request = response.data.getRequest;
                    })
            },
        },
        computed: {
            statusColor() {
                switch (this.request.status) {
                    case 'Received':
                        return "secondary";
                    case 'Assigned':
                        return "primary";
                    case 'Action Needed':
                        return "red";
                    case 'Processing':
                        return "teal";
                    case 'Completed':
                        return "green";
                    case 'On Hold':
                        return "red";
                    default:
                        return "primary"
                }
            },
        },
        async created() {
            await this.getRequest(this.id);
        },
        data: () => ({
            request: {},
            loading: false
        })
    }
</script>

<style>

</style>